'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.storage = void 0;
var data = new Map();
var memoryStorage = {
    setItem: function (key, value) {
        data.set(key, value);
    },
    getItem: function (key) {
        return data.get(key);
    },
    removeItem: function (key) {
        return data.delete(key);
    },
    clear: function () {
        data = new Map();
    },
};
var internalStorage;
if (typeof window !== 'undefined' && window.localStorage) {
    try {
        localStorage.setItem('test', 'test');
        localStorage.removeItem('test');
        internalStorage = localStorage;
    }
    catch (e) {
        internalStorage = memoryStorage;
    }
}
else {
    internalStorage = memoryStorage;
}
exports.storage = internalStorage;
